import { createSelector } from '@reduxjs/toolkit';

export const selectTitleSlice = (state: any) => state.taskDrawer || {};
export const selectCurrentTask = createSelector(selectTitleSlice, (slice) => slice.currentTask);
export const selectTaskDrawerLoading = createSelector(selectTitleSlice, (slice) => slice.loading);